import { demoPackages, demoReviews, demoSettings } from './demoData';
import type { Package, Review, StudioSettings } from '../types';

export interface PublicConfig { packages: Package[]; reviews: Review[]; settings: StudioSettings; }
const demoMode = import.meta.env.VITE_DEMO_MODE !== 'false';
let cache: Promise<PublicConfig> | null = null;

export function getPublicConfig(): Promise<PublicConfig> {
  if (demoMode) return Promise.resolve({ packages: demoPackages, reviews: demoReviews.filter(r => r.approved), settings: demoSettings });
  if (!cache) cache = fetch('/.netlify/functions/public-config').then(async r => {
    if (!r.ok) throw new Error('Could not load public configuration');
    const data = await r.json();
    return { packages: data.packages || [], reviews: data.reviews || [], settings: data.settings || demoSettings } as PublicConfig;
  }).catch(() => ({ packages: demoPackages, reviews: demoReviews.filter(r => r.approved), settings: demoSettings }));
  return cache;
}
